import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M11 15v2","key":"svg-1"}],["path",{"d":"M14 11v6","key":"svg-2"}],["path",{"d":"M17 13v4","key":"svg-3"}]]

const IconAlignBoxBottomRight = createReactComponent('outline', 'align-box-bottom-right', 'AlignBoxBottomRight', __iconNode);

export default IconAlignBoxBottomRight;